import { BrowserRouter, Route, Routes } from "react-router";
import { useValidateToken } from "../hooks";
import { RedirectHome } from "../ui/components";
import pages from "../ui/pages";

function AuthBootstrap() {
  useValidateToken();
  return null;
}

const Router = () => {
  return (
    <BrowserRouter>
      <AuthBootstrap />
      <Routes>
        <Route element={<RedirectHome />} path="/" />
        {pages.map(({ Element, path = null, ...props }) => (
          <Route
            element={<Element key={path || props.id} {...props} />}
            path={path || `/${props.id}`}
          />
        ))}
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
